module.exports = __webpack_public_path__ + "static/img/256.290b168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/256.png
// module id = 85Tz
// module chunks = 2